import { zl } from "../../../functions/utilities.js";

const MieszkaniecWydrukStawkiWoda = props => {

    const { wodaMsc, procent, licznik } = props;

    const wiersz = (
        <tr>
            <td 
                style={{
                    borderLeft: '1px solid black', 
                    borderRight: '1px solid black',
                    padding: '1mm 2mm',
                    textAlign: 'center',
                }}
            >    
                {licznik+1}                                     
            </td>
            <td 
                style={{
                    borderLeft: '1px solid black', 
                    borderRight: '1px solid black',
                    padding: '1mm 2mm',
                }}
            >
                {wodaMsc?.opis}                        
            </td>
            <td 
                style={{
                    borderLeft: '1px solid black', 
                    borderRight: '1px solid black',
                    padding: '1mm 2mm',
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }}
            >
                
            </td>
            <td 
                style={{
                    borderLeft: '1px solid black', 
                    borderRight: '1px solid black',
                    padding: '1mm 2mm',
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }}
            >
                
            </td>
            <td 
                style={{
                    borderLeft: '1px solid black', 
                    borderRight: '1px solid black',
                    padding: '1mm 2mm',
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }}
            >
               
            </td>
            <td
                style={{
                    borderLeft: '1px solid black', 
                    borderRight: '1px solid black',
                    padding: '1mm 2mm',
                    textAlign: 'right',
                    whiteSpace: 'nowrap'
                }}
            >
                {zl(procent?.saldo)}       
            </td>
        </tr>
    )

    return (
        wodaMsc && ( wiersz )
    );
};

export default MieszkaniecWydrukStawkiWoda;